export default "__VITE_ASSET__CAwQ3zzS__"